module.exports = __webpack_public_path__ + "static/media/gps.6c4b1df9.png";